import * as React from "react";

import { trackEvent } from "../analytics/tracking";
import CartSuggestedProductsProvider from "./CartSuggestedProductsProvider";
import CartSuggestedProductsCarousel from "./CartSuggestedProductsCarousel";
import PropTypes from 'prop-types';

/**
 * Render a carousel containing low price products that are not already carted
 *
 * We need to be careful not to put carted "Limit 1" products in this
 * carousel as these are bot valid additions
 */
const SuggestedLowPriceProducts = ({trackingPrefix}) => {

  React.useEffect(() => {
    if (trackingPrefix) {
      trackEvent(`${trackingPrefix}_low_price_csl_display`);
    }
  }, [trackingPrefix]);

  return (
    <CartSuggestedProductsProvider>
      <CartSuggestedProductsCarousel trackingPrefix={trackingPrefix} />
    </CartSuggestedProductsProvider>
  );
};

SuggestedLowPriceProducts.propTypes = {
  trackingPrefix: PropTypes.string.isRequired,
}

export default SuggestedLowPriceProducts;
